import { type ObjectValuesUnionType } from '../../utils/typing';

export const AppActionTypes = Object.freeze({
  ADD_FLASH_MESSAGE: 'APP:ADD_FLASH_MESSAGE',
  DEL_FLASH_MESSAGE: 'APP:DEL_FLASH_MESSAGE',
  CLEAR_SCOPE_FLASH_MESSAGE: 'APP:CLEAR_SCOPE_FLASH_MESSAGE',
});
export type AppActionType = ObjectValuesUnionType<typeof AppActionTypes>;
